module.exports = __webpack_public_path__ + "img/oldtraf.9611c7ab.jpg";